module.exports = __webpack_public_path__ + "img/chexiao.0c3eb96f.png";